import { useState } from "react";
import { Link } from "react-router-dom";
import { services } from "@/mocks/homeData";

export default function ServicesSection() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white" id="services">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-5">
            <i className="ri-sparkling-line text-[#C8F135] text-xs" style={{color: "#9bc400"}} />
            <span className="text-slate-500 text-xs font-semibold uppercase tracking-wider">Core AI Services</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-4">
            AI &amp; Beyond:
            <br />
            <span style={{color: "#9bc400"}}>Built for Enterprise Impact</span>
          </h2>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            From strategy to execution, we empower your enterprise with intelligent, agentic, and scalable AI solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((service) => (
            <div
              key={service.id}
              onMouseEnter={() => setHovered(service.id)}
              onMouseLeave={() => setHovered(null)}
              className={`group relative rounded-xl p-8 cursor-pointer transition-all duration-300 border ${
                hovered === service.id
                  ? "bg-black border-black text-white"
                  : "bg-white border-slate-100 hover:border-slate-200"
              }`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-lg mb-6 transition-all duration-300 ${
                hovered === service.id ? "bg-[#C8F135]" : "bg-slate-50"
              }`}>
                <i className={`${service.icon} text-xl transition-colors duration-300 ${
                  hovered === service.id ? "text-black" : "text-slate-600"
                }`} />
              </div>

              <h3 className={`text-lg font-bold mb-3 transition-colors duration-300 ${
                hovered === service.id ? "text-white" : "text-slate-900"
              }`}>
                {service.title}
              </h3>

              <p className={`text-sm leading-relaxed transition-colors duration-300 ${
                hovered === service.id ? "text-slate-300" : "text-slate-500"
              }`}>
                {service.description}
              </p>

              <div className={`mt-6 flex items-center gap-1 text-sm font-semibold transition-all duration-300 ${
                hovered === service.id ? "text-[#C8F135] opacity-100" : "text-slate-400 opacity-0 group-hover:opacity-100"
              }`}>
                Learn More <i className="ri-arrow-right-line" />
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-lg border-2 border-black text-black font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-black hover:text-[#C8F135] transition-all"
          >
            Explore All AI Services <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
